export default __webpack_public_path__ + "static/bussinessSuccessbg-ce6562449c2a3352fcc39680ec630d2a.png";